import React from 'react';
import { Button, Input, GridForm } from '../components';

class AccountInfoForm extends React.Component {

    getHandler(key, validate) {
        return event => {
            let value = event.target.value;
            let props = {
                valid: {}
            };
            props[key] = value;

            if (validate) {
                let validators = validate; //in case it's already an array
                if (!Array.isArray(validate)) {
                    validators = [
                        validate
                    ];
                }

                let isValid = validators.every((validator) => {
                    return validator(value);
                });

                props.valid[key] = isValid;
            }

            if (this.props.onChange) {
                this.props.onChange(key, props);
            }
        }
    }

    render () {
        const error = this.props.error ? this.props.error.message : '';

        return (
            <form className={['component-account-info-form', this.props.className].join(' ')} onSubmit={this.props.onComplete}>
                <GridForm>
                    <div className="form-group">
                        <label className="form-control">Email</label>
                        <Input className="form-control" type="text" value={this.props.value.email} onChange={this.getHandler('email')} />
                    </div>
                    <div className="form-group">
                        <label className="form-control">Password</label>
                        <Input className="form-control" type="password" onChange={this.getHandler('password')} />
                    </div>
                    <div className="form-group">
                        <label className="form-control">Confirm Password</label>
                        <Input className="form-control" type="password"  onChange={this.getHandler('confirmPassword')}
                        />
                    </div>
                </GridForm>
                <div>
                    <div className="form-errors">
                        <div className="form-error">{error}</div>
                    </div>
                    <Button type="button" onClick={this.props.onCancel}>Back</Button>
                    <Button className="primary" type="submit">Create Account</Button>
                </div>
            </form>
        )
    }
}

export default AccountInfoForm;



// WEBPACK FOOTER //
// ./web-app/components/account-info-form.jsx